import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import peter from "../assets/peter2.jpg";
import './Peter.css';

const Peter = () => {
  const { t } = useTranslation();

  const fadeIn = {
    initial: { opacity: 0, y: 20 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 1.5, ease: [0.19, 1, 0.22, 1] }
  };

  return (
    <div className="mag-wrapper">
      <section className="mag-editorial-hero">
        <div className="mag-hero-container">
          <div className="mag-hero-text-side">
            <motion.span
              className="mag-label-accent"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1 }}
            >
              {t('peter.category')}
            </motion.span>

            <motion.h1
              className="mag-display-title"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1.2, delay: 0.2 }}
            >
              {t('peter.name')}
            </motion.h1>

            <motion.div
              className="mag-hero-divider"
              initial={{ width: 0 }}
              animate={{ width: "80px" }}
              transition={{ duration: 1.5, delay: 0.5 }}
            />

            <motion.p
              className="mag-hero-intro-text"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1, delay: 0.8 }}
            >
              {t('peter.heroSub')}
            </motion.p>
          </div>

          <div className="mag-hero-image-side">
            <motion.div
              className="mag-hero-img-frame"
              initial={{ clipPath: 'inset(100% 0% 0% 0%)' }}
              animate={{ clipPath: 'inset(0% 0% 0% 0%)' }}
              transition={{ duration: 1.8, ease: [0.19, 1, 0.22, 1] }}
            >
              <img src={peter} alt={t('peter.name')} />
            </motion.div>
            <motion.span className="mag-hero-caption" {...fadeIn}>
            </motion.span>
          </div>
        </div>
      </section>


      <motion.section className="mag-intro-quote-wrapper" {...fadeIn}>
        <blockquote className="mag-main-quote">
          {t('peter2.introQuote')}
        </blockquote>
      </motion.section>

      <section className="mag-article-grid">
        <motion.div className="mag-text-col" {...fadeIn}>
          <p className="mag-dropcap-para">
            <span className="mag-dropcap">P</span>
            {t('peter2.article.para1')}
          </p>
          <p>
            {t('peter2.article.para2')}
          </p>
          <p>
            {t('peter2.article.para3')}
          </p>
        </motion.div>

        <motion.div className="mag-text-col" {...fadeIn}>
          <p>
            {t('peter2.article.para4')}
          </p>
          <p>
            {t('peter2.article.para5')}
          </p>
          <p>
            {t('peter2.article.para6')}
          </p>

          <div className="mag-source-footer">
            <span className="mag-source-text">
              {t('peter2.article.sourceLabel')}, <em className="mag-source-highlight">{t('peter2.article.sourceName')}</em>, {t('peter2.article.sourceNumber')}
            </span>
          </div>
        </motion.div>
      </section>

      <section className="mag-questionnaire">
        <div className="mag-q-container">
          <motion.h3 {...fadeIn}>{t('peter.qna.title')}</motion.h3>
          <div className="mag-q-grid">
            <motion.div className="mag-q-item" {...fadeIn}>
              <strong>{t('peter.qna.q1.label')}</strong>
              <p>{t('peter.qna.q1.answer')}</p>
            </motion.div>
            <motion.div className="mag-q-item" {...fadeIn}>
              <strong>{t('peter.qna.q2.label')}</strong>
              <p>{t('peter.qna.q2.answer')}</p>
            </motion.div>
            <motion.div className="mag-q-item" {...fadeIn}>
              <strong>{t('peter.qna.q3.label')}</strong>
              <p>{t('peter.qna.q3.answer')}</p>
            </motion.div>
            <motion.div className="mag-q-item" {...fadeIn}>
              <strong>{t('peter.qna.q4.label')}</strong>
              <p>{t('peter.qna.q4.answer')}</p>
            </motion.div>
          </div>
        </div>
      </section>


      <footer className="mag-footer">
        <div className="mag-footer-inner">
          <h2 className="mag-footer-title">{t('peter.footer.title')}</h2>
          <p>{t('peter.footer.sub')}</p>
          <a href="mailto:peter@dinmaklareahus.se" className="mag-contact-btn">{t('peter.footer.btn')}</a>
        </div>
      </footer>
    </div>
  );
};

export default Peter;